import { Grid, IconButton, Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { getAllExpense, getAllIncome } from "../api";
import { useSnackbar } from "notistack";
import LoadingContent from "../components/common/LoadingContent";
import IncomeCard from "../components/cards/IncomeCard";
import ExpenseCard from "../components/cards/ExpenseCard";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Link } from "react-router-dom";

const AccountingManage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [expenses, setExpenses] = useState([]);
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const fetchIncomes = () => {
    setLoading(true);
    getAllIncome({
      filter: {
        status: ["PENDING", "ACTIVE"],
      },
    })
      .then((res) => setIncomes(res.data.rows))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false));
  };

  const fetchExpenses = () => {
    setLoading2(true);
    getAllExpense({
      filter: {
        status: ["PENDING", "ACTIVE"],
      },
    })
      .then((res) => setExpenses(res.data.rows))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading2(false));
  };

  useEffect(() => {
    fetchIncomes();
    fetchExpenses();
  }, []);

  return (
    <>
      <Link to={"/accounting"}>
        <IconButton>
          <ArrowBackRoundedIcon />
        </IconButton>
      </Link>

      <LoadingContent loading={loading || loading2}>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <Stack>
              <Typography variant="h6" mb={2} textAlign="center">
                Income
              </Typography>
              {incomes.length > 0 ? (
                incomes.map((expense) => (
                  <IncomeCard
                    key={expense.id}
                    data={expense}
                    enqueueSnackbar={enqueueSnackbar}
                    approve
                    reset={fetchIncomes}
                  />
                ))
              ) : (
                <Typography sx={{ textAlign: "center", py: 5 }}>
                  No income found!
                </Typography>
              )}
            </Stack>
          </Grid>

          <Grid item sm={6}>
            <Stack>
              <Typography variant="h6" mb={2} textAlign="center">
                Expense
              </Typography>
              {expenses.length > 0 ? (
                expenses.map((expense) => (
                  <ExpenseCard
                    key={expense.id}
                    data={expense}
                    enqueueSnackbar={enqueueSnackbar}
                    approve
                    reset={fetchExpenses}
                  />
                ))
              ) : (
                <Typography sx={{ textAlign: "center", py: 5 }}>
                  No expense found!
                </Typography>
              )}
            </Stack>
          </Grid>
        </Grid>
      </LoadingContent>
    </>
  );
};

export default AccountingManage;
